export default __webpack_public_path__ + "static/media/12.ef08e438.png";